module.exports = __webpack_public_path__ + "static/media/stlouis.450d1281.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/stlouis.png
// module id = 91
// module chunks = 0